var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavAuditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.14286C0 0.511675 0.511674 0 1.14286 0H14.8571C15.4883 0 16 0.511675 16 1.14286V8.61158C15.3276 8.22262 14.5469 8 13.7143 8C11.1895 8 9.14285 10.0467 9.14285 12.5714C9.14285 13.9368 9.74143 15.1623 10.6905 16H0V1.14286ZM2.28571 2.28571H13.7143V4.57143H2.28571V2.28571ZM7.99999 5.71429H2.28571V8H7.99999V5.71429ZM2.28571 9.14286H5.71428V11.4286H2.28571V9.14286Z",
    fill: "#F6F8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 14.8571L14.7745 13.6315M15.3487 12.2457C15.3487 13.3282 14.4712 14.2058 13.3887 14.2058C12.3062 14.2058 11.4287 13.3282 11.4287 12.2457C11.4287 11.1632 12.3062 10.2857 13.3887 10.2857C14.4712 10.2857 15.3487 11.1632 15.3487 12.2457Z",
    stroke: "#F6F8F8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavAuditIcon);
export default __webpack_public_path__ + "static/media/nav-audit-icon.0ca39804.svg";
export { ForwardRef as ReactComponent };